import request from '@/utils/request';
// 自定义地址列表
export const getCustomAddressList = (params: any) =>
  request({
    url: 'CustomAddress/customAddressList',
    method: 'get',
    params
  });
// 删除自定义地址
export const delCustomAddress = (data: any) =>
  request({
    url: 'CustomAddress/customAddress',
    method: 'DELETE',
    data
  });
// 导入自定义地址
export const importCustomAddress = (data: any) =>
  request({
    url: 'CustomAddress/importCustomAddress',
    method: 'post',
    data
  });
// 添加自定义地址
export const addCustomAddress = (data: any) =>
  request({
    url: 'CustomAddress/customAddress',
    method: 'post',
    data
  });

// 编辑自定义地址
export const editCustomAddress = (data: any) =>
  request({
    url: 'CustomAddress/customAddress',
    method: 'put',
    data
  });
